
export { E as LayoutFeaturedResources } from "./main-CZWcWLqa.js"